import { FormattedMessage, useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import {
    Adg4BannerAlert,
    BannerProps
} from "@/patterns/adg4/banner-alert/banner-alert";

export const Team24BannerAlert = () => {
    const intl = useIntl();

    const bannerAfterEvent: BannerProps = {
        identifier: "HomePageTemplateV2.team-24-banner-alert.afterEvent",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.text.team-24-banner-alert.afterEvent"
                defaultMessage="<strong>Catch the keynote announcements, curated session playlists, and exclusive content for free.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.linkText.team-24-banner-alert.afterEvent",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/team-digital?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=wac_homepage_butterbar&utm_medium=banner-alert-after_event",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.dataLabel.team-24-banner-alert.afterEvent",
                defaultMessage: "Watch now"
            }),
            "data-label-english": "Watch now"
        }
    };

    //leaving this gate to turn off the banner quickly if needed
    //it should be removed once the banner is no longer live
    if (FeatureGates.checkGate("wac-team24-banner-alert-after-event")) {
        return (
            <UFOSegment name="homepage-v2-bannerAlert">
                <Adg4BannerAlert {...bannerAfterEvent} />
            </UFOSegment>
        );
    }

    return null;
};
